/** Folhas que sobem por cima da Agenda (docs/design/pranchas/08-acoes-da-agenda.png). */
import { PLAN_INFO, formatMoneyShort, toIso, zonedToUtc } from '@lindeza/core';
import { useAccess } from '@lindeza/core/hooks';
import { useNavigate } from 'react-router-dom';
import { Sheet } from '../../components/ui';
import { AppointmentSheet } from './AppointmentSheet';
import { BlockSheet } from './BlockSheet';
import { ChargeScreen } from './ChargeScreen';
import { NewAppointmentSheet } from './NewAppointmentSheet';
import { PickTimeSheet } from './PickTimeSheet';
import { TomorrowSheet } from './TomorrowSheet';

export type SheetState =
  | { kind: 'new'; start: string; clientId?: string }
  | { kind: 'appt'; id: string }
  | { kind: 'pay'; id: string }
  | { kind: 'block'; start: string; blockId?: string }
  | { kind: 'tomorrow' }
  | { kind: 'pick'; date: string; clientId?: string }
  | null;

export function AgendaSheets({
  sheet,
  setSheet,
  today,
  now,
  timezone,
}: {
  sheet: SheetState;
  setSheet: (s: SheetState) => void;
  today: string;
  now: number;
  timezone: string;
}) {
  const close = () => setSheet(null);
  const access = useAccess();
  // Teste acabou (bloqueio suave, épico 9.3): ver continua; marcar pede assinatura.
  if ((sheet?.kind === 'new' || sheet?.kind === 'pick') && access && !access.canCreate) return <SubscribeSheet onClose={close} />;
  switch (sheet?.kind) {
    case 'new':
      return <NewAppointmentSheet start={sheet.start} clientId={sheet.clientId} onClose={close} />;
    case 'appt':
      return <AppointmentSheet id={sheet.id} onClose={close} onCharge={() => setSheet({ kind: 'pay', id: sheet.id })} />;
    case 'pay':
      return <ChargeScreen id={sheet.id} onClose={close} />;
    case 'block':
      return <BlockSheet start={sheet.start} blockId={sheet.blockId} onClose={close} />;
    case 'tomorrow':
      return <TomorrowSheet onClose={close} />;
    case 'pick':
      return (
        <PickTimeSheet
          date={sheet.date}
          onPick={(start) => setSheet({ kind: 'new', start, ...(sheet.clientId ? { clientId: sheet.clientId } : {}) })}
          onClose={close}
          defaultStart={defaultStartFor(sheet.date, today, timezone, now)}
        />
      );
    default:
      return null;
  }
}

/** "Marcar" sem horário escolhido: hoje, a próxima meia hora; outro dia, 9h. */
function defaultStartFor(date: string, today: string, tz: string, now: number): string {
  if (date !== today) return toIso(zonedToUtc(date, '09:00', tz));
  const step = 30 * 60_000;
  return toIso(Math.ceil(now / step) * step);
}

function SubscribeSheet({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  return (
    <Sheet title="Para marcar, assine um plano" sub="Sua agenda e suas clientes continuam salvas, e você continua vendo tudo." onClose={onClose}>
      <div className="stack">
        <button
          className="btn btn--primary btn--lg btn--block"
          onClick={() => {
            onClose();
            navigate('/ajustes/plano');
          }}
        >
          Assinar o {PLAN_INFO.essencial.name}
        </button>
        <p className="small muted" style={{ textAlign: 'center' }}>
          {formatMoneyShort(PLAN_INFO.essencial.priceCents)} por mês, com Pix ou cartão
        </p>
        <button className="btn btn--ghost btn--block" onClick={onClose}>
          Agora não
        </button>
      </div>
    </Sheet>
  );
}
